import React, { useEffect, useState } from "react";
import { LogIn, Clock } from "lucide-react";

export default function SessionExpiredModal() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handler = () => setVisible(true);
    window.addEventListener("session-expired", handler);
    return () => window.removeEventListener("session-expired", handler);
  }, []);

  if (!visible) return null;

  const handleReconnect = () => {
    window.location.href = "/";
  };

  return (
    <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl p-8 w-[360px] flex flex-col items-center gap-5 text-center">
        <div className="w-14 h-14 rounded-full bg-[#840040]/10 flex items-center justify-center">
          <Clock className="w-7 h-7 text-[#840040]" />
        </div>
        <div>
          <h2 className="text-lg font-bold text-slate-900 mb-1">
            Session expirée
          </h2>
          <p className="text-sm text-slate-500">
            Votre session a expiré. Veuillez vous reconnecter pour continuer.
          </p>
        </div>
        <button
          onClick={handleReconnect}
          className="flex items-center gap-2 h-10 px-6 rounded-xl text-sm font-semibold text-white bg-[#840040] hover:bg-[#6c0034] transition-colors w-full justify-center"
        >
          <LogIn className="w-4 h-4" />
          Se reconnecter
        </button>
      </div>
    </div>
  );
}
